import {
  SET_CLAIM_FORM_ACTIVATION_REQUEST,
  SET_CLAIM_FORM_ACTIVATION_SUCCESS,
  SET_CLAIM_FORM_ACTIVATION_FAILURE,
} from "./types";

import { setClaimFormActivation } from "../../services/claimFormActivationService";

// Basic action creators
export const setClaimFormActivationRequest = () => ({
  type: SET_CLAIM_FORM_ACTIVATION_REQUEST,
});

export const setClaimFormActivationSuccess = (updatedPackage) => ({
  type: SET_CLAIM_FORM_ACTIVATION_SUCCESS,
  payload: updatedPackage,
});

export const setClaimFormActivationFailure = (error) => ({
  type: SET_CLAIM_FORM_ACTIVATION_FAILURE,
  payload: error,
});


export const setClaimFormActivationAction =
  (packageId, claim_form_activated) => async (dispatch) => {
    dispatch(setClaimFormActivationRequest());

    try {
      const response = await setClaimFormActivation(packageId, claim_form_activated);

      if (response.success) {
        dispatch(setClaimFormActivationSuccess(response.data));
      } else {
        dispatch(setClaimFormActivationFailure(response.error));
      }

      return response;
    } catch (error) {
      dispatch(setClaimFormActivationFailure(error.message));
      return { success: false, error: error.message };
    }
  };